import React from 'react';
import './SheetInputs.scss';

/**
 * Clickable sheet checkbox — matches ☑ / ☐ glyph look used in layout preview.
 */
const SheetCheckbox = ({
  checked = false,
  disabled = false,
  title,
  textAlign = 'center',
  onChange
}) => {
  const handleToggle = e => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    if (onChange) onChange(!checked);
  };

  return (
    <button
      type="button"
      className={[
        'dochub-sheet-checkbox',
        checked ? 'is-checked' : 'is-unchecked',
        disabled ? 'is-disabled' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ textAlign }}
      title={title}
      aria-label={title || (checked ? 'Checked' : 'Unchecked')}
      aria-pressed={checked}
      disabled={disabled}
      onClick={handleToggle}
      onMouseDown={e => e.stopPropagation()}
    >
      <span className="dochub-sheet-checkbox__glyph" aria-hidden="true">
        {checked ? '☑' : '☐'}
      </span>
    </button>
  );
};

export default SheetCheckbox;
